import { API_ERROR_CODE } from "./dataCenter";

export function getMessge(code: any) {
  let msg = "서버와의 연결이 원활하지 않습니다.";
  switch (code) {
    /*
        API ERROR MESSAGE
        */
    case API_ERROR_CODE.INTERNAL_SERVER_ERROR:
      msg = "서버와의 연결이 원활하지 않습니다.";
      break;
    case API_ERROR_CODE.DB_API_ERROR:
      msg = "올바르지 않은 데이터 접근입니다.";
      break;
    case API_ERROR_CODE.DATA_IS_NULL:
      msg = "존재하지 않는 데이터 입니다.";
      break;
    case API_ERROR_CODE.DATA_ALREADY_EXIST:
      msg = "이미 존재하는 데이터 입니다.";
      break;
    case API_ERROR_CODE.DATA_IS_INVALID:
    case API_ERROR_CODE.DATA_HAVE_NO_REQUIRED:
    case API_ERROR_CODE.DATA_HAVE_EXCLUSIVE:
      msg = "올바르지 않은 데이터 입니다.";
      break;
    case API_ERROR_CODE.PERMISSION_INVALID:
      msg = "접근 권한이 없습니다.";
      break;
    case API_ERROR_CODE.BUSINESSES_CODE_INVALID:
      msg = "사업자 등록 정보가 올바르지 않습니다.";
      break;
    case API_ERROR_CODE.BUSINESSES_CODE_EXIST:
      msg = "해당 사업자 등록 번호를 가진 업체가 이미 등록되어 있습니다.";
      break;
    case API_ERROR_CODE.INVITE_CODE_INVALID:
      msg = "초대 코드가 올바르지 않습니다.";
      break;
    case API_ERROR_CODE.INVITE_CODE_EXPIRED:
      msg = "해당 초대 코드가 만료되었습니다.";
      break;
    case API_ERROR_CODE.INVITE_TYPE_INVALID:
      msg = "올바르지 않은 초대 코드 입니다.";
      break;
    case API_ERROR_CODE.PERMISSION_DENIED:
      msg = "해지된 계정입니다. 토더에 문의해주세요.";
      break;
  }
  return msg;
}
